export default __webpack_public_path__ + "static/media/n_wdt_c_0.f76ec277.mp3";